import { defineStore } from 'pinia'
import listasApi from '@/app/services/listas';

export const useListasStore = defineStore('listas', {

  state: () => ({
    clientes: [],
    vendedores: [],
    fornecedores: [],
    contas_pagar_categorias: [],
    chaves_pix: [],
    registros_whatsapp: [],
    whatsapp_instances: [],
  }),

  actions: {

    async fetchListas(listas) {
      const lists = await listasApi.fetchListas(listas);

      this.processLists(lists);
    },

    processLists(lists) {
      Object.keys(lists).forEach((key) => {
        this[key] = lists[key];
      });
    }
  },

})


